module.exports = __webpack_public_path__ + "img/edf25393-7247-4909-ae4b-d72b853e0e5a.91dd1154.webp";